import { useTranslation } from "react-i18next";

import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
import { buildCorrectedTextSegments } from "./utils";

interface CorrectedAnswerPanelProps {
    readonly correctedVersion: string;
    readonly className?: string;
}

export function CorrectedAnswerPanel({
    correctedVersion,
    className,
}: CorrectedAnswerPanelProps) {
    const { t } = useTranslation();

    if (!correctedVersion.trim()) return null;

    return (
        <div className={cn("flex flex-col space-y-2", className)} data-corrected-answer-panel>
            <Label className="font-ui text-xs font-medium text-success uppercase tracking-widest">
                {t("simulation.results.reviewDialog.correctedVersion", {
                    defaultValue: "Corrected Version",
                })}
            </Label>
            <div className="font-ui flex-1 rounded-md border border-success/20 bg-success/5 p-3 text-sm leading-relaxed text-foreground/90 whitespace-pre-wrap selection:bg-success/20">
                {buildCorrectedTextSegments(correctedVersion)}
            </div>
        </div>
    );
}
